var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: "width:" + _vm.width + ";height:" + _vm.height },
    [
      _vm.fileType === "image"
        ? _c("BjKeyImage", {
            attrs: {
              height: _vm.height,
              width: _vm.width,
              url: _vm.fileUrl,
              preview: _vm.preview,
            },
          })
        : _vm.fileType === "video"
        ? _c("BjKeyVideo", {
            attrs: { height: _vm.height, width: _vm.width, url: _vm.fileUrl },
          })
        : _vm.fileType === "application"
        ? _c("div", [
            _c("i", { staticClass: "font-icon el-icon-folder-checked" }),
            _c("p", { staticClass: "text-center" }, [
              _vm._v(
                _vm._s(_vm.fileUrl && _vm.fileUrl.split("/").slice(-1)[0])
              ),
            ]),
          ])
        : _vm.fileType === "text"
        ? _c("div", [
            _c("i", { staticClass: "font-icon el-icon-document" }),
            _c("span", { staticClass: "text-center" }, [
              _vm._v(
                _vm._s(_vm.fileUrl && _vm.fileUrl.split("/").slice(-1)[0])
              ),
            ]),
          ])
        : _c("span", [_vm._v(_vm._s(_vm.fileUrl))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }